import {
    Directive,
    ElementRef,
    inject,
    input,
    OnChanges, output,
    SimpleChanges,
} from '@angular/core';
import { PipeService } from '../../filters/pipe-transformation.service';

// HACK: Extract this + it's usages to a component seems to be a better implementation
@Directive({
    selector: '[mon-set-background-color], [monSetBackgroundColor]',
    standalone: false,
})
export class MonSetBackgroundColorDirective implements OnChanges {
    color = input.required();
    count = input(0);
    maxCount = input(0);

    percentage = output<number>();

    elem = inject(ElementRef);
    ng2PipeService = inject(PipeService);

    ngOnChanges (changes: SimpleChanges): void {
        if (
            changes.color ||
            changes.count ||
            changes.maxCount
        ) {
            this.setBackgroundColor();
        }
    }

    private setBackgroundColor (): void {
        const color = this.toRgb(this.color());
        const opacity = this.ng2PipeService.get('number')(this.count() / this.maxCount(), '1.0-2');
        this.percentage.emit(opacity);
        this.elem.nativeElement.style.setProperty('background-color', 'rgba(' + color + ', ' + opacity + ')', 'important');
        this.elem.nativeElement.style.setProperty('--bs-table-bg-state', 'transparent');
    }

    private toRgb (color: any): string {
        if (/^#[0-9A-F]{6}$/i.test(color)) {
            let c = color.substring(1).split('');
            if (c.length === 3) {
                c = [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c = '0x' + c.join('');
            return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',');
        }

        return color;
    }
}
